import React from 'react';
import { Section, SplitScreen } from '../../ui/layouts/SplitScreen';
import Wrapper from '../../ui/Wrapper';
import Headline from '../../ui/Headline';
import Text from '../../ui/Text';
import Button from '../../ui/controls/Button';
import HeaderWithBanner from '../../ui/HeaderWithBanner';
import bannerImage from './assets/banner.png';

import getTexts from 'utils/localization';
const t = getTexts();

class WelcomeWindow extends React.Component {
    onExploreClickHandler = () => {
        this.props.hideModal('WELCOME_WINDOW');
    };

    onSkipClickHandler = () => {
        this.props.hideModal('WELCOME_WINDOW');
    };

    render() {
        return (
            <SplitScreen white>
                <Section rounded="bottom" white height="60">
                    <HeaderWithBanner>
                        <img src={bannerImage} alt="Banner" width="100%" />
                    </HeaderWithBanner>
                </Section>
                <Section transperent height="40">
                    <Headline align="center">{t.welcome}!</Headline>
                    <Text align="center">
                        {t.registrationComplete},{' '}
                        {this.props.modalData.firstName}.
                    </Text>

                    <Wrapper padding="0px" align="center">
                        <Button
                            onClick={this.onExploreClickHandler}
                            width="230px"
                            accent
                            size="x2"
                        >
                            {t.explore}
                        </Button>
                    </Wrapper>

                    <Wrapper padding="0px" align="center">
                        {/* <Button
                            onClick={this.onSkipClickHandler}
                            link
                            grey
                            size="x05"
                        >
                            {t.skip}
                        </Button> */}
                    </Wrapper>
                </Section>
            </SplitScreen>
        );
    }
}

export default WelcomeWindow;
